import React from 'react';
import bannerImage from "..//img/aaaservices/banner 7-04-25[1].jpg";
import brochure from '../img/TOOL & FIXURE DESIGN BROCHURE V3.pdf';

import Digitalprenceskillall from './Digitalprenceskillall';

const Outdoor = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = brochure;
    link.download = 'Brochure.pdf';
    link.click();
  };

  const handleEnquiry = () => {
    console.log("Enquiry button clicked");
  };

  return (
    <div>
      {/* Banner Image */}
      {/* <div>
        <img
          src={bannerImage}
          alt="Banner"
          style={{ width: '100%', height: 'auto', maxHeight: '650px', objectFit: 'cover' }}
        />
      </div> */}

      {/* <PCMobileApplications /> */}
      <Digitalprenceskillall/>
    </div>
  );
};

export default Outdoor;
